import React, { useEffect, useState } from 'react';
import RestUtilities from '../../services/RestUtilities';

import {
  MenuItem,
  Box,
  Typography,
  Button,
  SelectChangeEvent,
} from '@mui/material';
import SmallSelect from '../../components/Common/SmallSelect';

import { useNavigate } from 'react-router-dom';

import {
  loadingState,
  paginationModelState,
  toastState,
} from '../../state/RecoilState';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Booking } from '../../@types/api';
import dayjs from 'dayjs';
import { bookingStatus, colDateFormat } from '../../Constants';

const Bookings = () => {
  const navigate = useNavigate();
  const [paginationModel, setPaginationModel] =
    useRecoilState(paginationModelState);
  const setToast = useSetRecoilState(toastState);
  const setLoading = useSetRecoilState(loadingState);
  const [status, setStatus] = useState<number>(bookingStatus.CONFIRMED);
  const [data, setData] = useState<Booking[]>([]);

  useEffect(() => {
    const getAllData = async () => {
      setLoading(true);
      const res = await RestUtilities.get('/api/booking/Get');
      setData(res.content);
      setToast('Bookings Loaded');
      setLoading(false);
    };
    if (data.length === 0) {
      getAllData();
    }
  }, [data, setLoading, setToast]);

  const handleStatusChange = (event: SelectChangeEvent<unknown>) => {
    setStatus(Number(event.target.value));
  };

  const columns: GridColDef[] = [
    {
      headerName: 'ID',
      field: 'bookingId',
      type: 'number',
      sortable: true,
      headerAlign: 'left',
      width: 80,
      renderCell: (params) => (
        <Button
          onClick={(event) => navigate(`/booking/edit/${params.row.bookingId}`)}
          size='small'
          variant='contained'
          sx={{ my: 3 }}
          color='primary'
        >
          {params.row.bookingId}
        </Button>
      ),
    },
    {
      headerName: 'Event Date',
      field: 'eventDate',
      sortable: false,
      valueGetter: (params) => dayjs(params.value).format(colDateFormat),
    },
    {
      headerName: 'Name',
      field: 'clientName',
      width: 180,
    },
    {
      headerName: 'Artist',
      field: 'artistName',
      width: 180,
    },
    {
      headerName: 'Venue',
      field: 'venueName',
      width: 200,
    },
    {
      headerName: 'Location',
      field: 'location',
      width: 400,
    },
    { headerName: 'Status', field: 'statusDescription', sortable: false },
  ];

  const filtered =
    status > bookingStatus.NONE
      ? data.filter((x) => x.statusId === status)
      : data;
  return (
    <Box>
      <Box my={1} display='flex' justifyContent={'space-between'}>
        <Typography variant='h5'>Bookings</Typography>
        <SmallSelect
          id='status-select'
          value={status}
          onChange={handleStatusChange}
          variant='outlined'
        >
          <MenuItem value={bookingStatus.CONFIRMED}>Confirmed</MenuItem>
          <MenuItem value={bookingStatus.OPEN}>New</MenuItem>
          <MenuItem value={bookingStatus.CANCELLED}>Cancelled</MenuItem>
          <MenuItem value={bookingStatus.COMPLETE}>Recent</MenuItem>
          <MenuItem value={bookingStatus.ONHOLD}>On Hold</MenuItem>
          <MenuItem value={bookingStatus.NONE}>All</MenuItem>
        </SmallSelect>
      </Box>
      <DataGrid
        rows={filtered}
        columns={columns}
        getRowId={(row) => row.bookingId}
        pageSizeOptions={[25, 50, 100, 250]}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
      />
    </Box>
  );
};
export default Bookings;
